import {
  isBefore,
  isSameDay,
  isSameHour,
  isSameMinute,
  setMinutes,
} from 'date-fns';

const date = {
  key: 'date',
  label: '日時',
  width: '400px',
};

const method = {
  key: 'method',
  label: '実行方法',
  width: '200px',
};
const status = {
  key: 'status',
  label: 'ステータス',
  width: '200px',
};
const masterStoreName = {
  key: 'masterStoreName',
  label: '店舗名',
  width: '200px',
};
export const executionTableColumn = {
  date,
  method,
  status,
  masterStoreName,
} as const;

const reservationTableColumns = [
  executionTableColumn.date,
  executionTableColumn.method,
  executionTableColumn.status,
] as const;

export const executionTableThs = reservationTableColumns.map((tableColumn) => {
  return {
    label: tableColumn.label,
    minWidth: tableColumn.width,
  };
});

export const MIN_SCHEDULED_DATE_PLUS_MINUTES = 5;

export const convertStrToFormatDate = (
  str: string
): `${string}/${string}/${string} ${string}:${string}:00` => {
  // example: 2022 11 01 11 00
  const year = str.substr(0, 4);
  const month = str.substr(4, 2);
  const day = str.substr(6, 2);
  const hour = str.substr(8, 2);
  const minutes = str.substr(10, 2);
  return `${year}/${month}/${day} ${hour}:${minutes}:00` as const;
};

export const calcMinTime = (plusMinutes: number): Date => {
  const time = setMinutes(new Date(), new Date().getMinutes() + plusMinutes);
  time.setSeconds(0);
  return time;
};

export const calcMinScheduledTime = (ScheduledDate: Date): Date => {
  const time = setMinutes(
    ScheduledDate,
    ScheduledDate.getMinutes() - MIN_SCHEDULED_DATE_PLUS_MINUTES
  );
  time.setSeconds(0);
  return time;
};

export const isSameDayTime = (targetDate: Date, minTime: Date): boolean => {
  return (
    isSameDay(targetDate, minTime) &&
    isSameHour(targetDate, minTime) &&
    isSameMinute(targetDate, minTime)
  );
};

export const isValidateBeforeDate = (
  targetDate: Date,
  minTime: Date
): boolean => {
  return isBefore(targetDate, minTime) || isSameDayTime(targetDate, minTime);
};

export const minScheduledTimeMessage =
  `現在配信予定の日時設定の登録から最低${MIN_SCHEDULED_DATE_PLUS_MINUTES}分の間隔がないと更新、削除は出来ません。` as const;

export const importStatus = {
  // all: -1, // バックエンドでは存在しないstatus
  reserve: 0,
  running: 1,
  success: 2,
  error: 3,
  // 削除
  deleteReserve: 4,
  deleteRunning: 5,
  deleteSuccess: 6,
  deleteError: 7,
} as const;

export const menuManagementJobMap = {
  // [importStatus.all]: '全て表示',
  [importStatus.reserve]: '予約中',
  [importStatus.running]: '実行中',
  [importStatus.success]: '成功',
  [importStatus.error]: 'エラー',

  // 削除
  [importStatus.deleteReserve]: '削除予約中',
  [importStatus.deleteRunning]: '削除実行中',
  [importStatus.deleteSuccess]: '削除成功',
  [importStatus.deleteError]: '削除エラー',
} as const;

export type MenuManagementJobTargetStatus = keyof typeof menuManagementJobMap;

export type TargetMasterStore = {
  name: string;
  status: MenuManagementJobTargetStatus;
};

export const deliveryMethodImmediately = 'immediately' as const;
export const deliveryMethodDateAndTime = 'dateAndTime' as const;
export const deliveryMethodMap = {
  [deliveryMethodImmediately]: '即時配信',
  [deliveryMethodDateAndTime]: '日時配信',
} as const;
export type DeliveryMethodKey = keyof typeof deliveryMethodMap;
export type DeliveryMethod = Util.ValueOf<typeof deliveryMethodMap>;

export const menuManagementJobTargetThs = [
  {
    minWidth: '200px',
    label: '店舗名',
  },
  {
    minWidth: '200px',
    label: 'ステータス',
  },
];
